var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "100px",
  width: "100px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 82 81",
  x: "0px",
  y: "0px"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, -17.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.0787075,33.0882353 L33.4558824,64.3382354",
  strokeWidth: 15,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("polygon", {
  transform: "translate(72.134903, 29.456845) rotate(53.000000) translate(-72.134903, -29.456845) ",
  points: "68.5556866 14.7245467 97.9172862 36.850099 46.3525203 44.1891435"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "48.5294118 28.6764706 0 28.6764706 0 97.7941176 69.1176471 97.7941176 69.1176471 50 58.0882353 61.0294118 58.0882353 86.7647059 11.0294118 86.7647059 11.0294118 39.7058824 37.5 39.7058824"
})))));
export default SvgExternalLink;